import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>This website (the "Website") is the website of JD Sports
        Fashion plc ("JD Sports Fashion plc", "us" or "we"). The pages on the Website are published
        by Mission Labs Limited ("Mission Labs") and by Investis Limited ("Investis") on behalf of
        JD Sports Fashion plc.
        <br />
        <br />
        Please read these terms and conditions of use of the Website carefully as by using the
        Website you agree to be bound by them. We reserve the right to vary the conditions of use at
        any time and will post any variations here. You are advised to review the conditions of use
        on a regular basis as you will be deemed to have accepted variations if you continue to use
        the Website after they have been posted.
        <br />
        <br />
        If you do not agree to abide by these conditions of use you should not use the Website in
        any way. Information published by Investis on the Website is supplied by JD Sports Fashion
        plc and, where indicated, by certain third parties. Investis and JD Sports Fashion plc take
        every care and precaution to ensure that information published on the Website is accurate
        when posted and regularly updated, but neither Investis nor JD Sports Fashion plc guarantee
        or can be held liable for its accuracy or timeliness and Investis or JD Sports Fashion plc
        may change the information at any time without notice. You must not rely on the information
        on the Website and you acknowledge that you must take appropriate steps to verify this
        information before acting on it.
        <br />
        <br />
        JD Sports Fashion plc, Mission Labs and Investis publish the website “As Is” without any
        warranty of any kind, express or implied, as to the operation of the website, the accuracy
        of the information or the products or service referred to on the website (in so far as such
        warranties may be excluded under any relevant law) and to the extent permitted by law,
        neither JD Sports Fashion plc, Investis or Mission Labs shall be liable for any losses or
        damage whether direct or indirect (including without limitation direct or indirect loss of
        profits, consequential, special or otherwise incidental that may result from the use of the
        website howsoever arising.
        <br />
        <br />
        The information contained in the Website is not an invitation to invest in shares or other
        securities, or any other products or services or otherwise deal in these or enter into a
        contract with JD Sports Fashion plc or any other company. The information provided should
        not be relied upon in connection with any investment decision. You should always seek
        appropriate professional advice in relation to such.
        <br />
        <br />
        The past performance of JD Sports Fashion plc or any other company referred to on the
        Website cannot be relied upon as a guide to its future performance. The price of shares and
        the income derived from them can go down as well as up and investors may not recoup the
        amount originally invested.
        <br />
        <br />
        Any reference to any product or service which has been or may be provided by JD Sports
        Fashion plc or any other company does not amount to a promise that such product or service
        will be available at any time. Changes to or improvements in such products or services may
        be made at any time without notice.
        <br />
        <br />
        Copyright in the design and architecture of the Website is owned by Mission Labs and in part
        by Investis. JD Sports Fashion plc owns the copyright in the content published on the
        Website except where otherwise indicated by a third party's proprietary notice. Images,
        trade marks and brands are also protected by other intellectual property laws and may not be
        reproduced or appropriated in any manner without written permission of their respective
        owners. Unless specifically prohibited by a notice published on any page, you may make a
        print copy of such parts of the Website as you may reasonably require for your own personal
        use provided that any copy has attached to it any relevant proprietary notices and/or
        disclaimers. All other use is prohibited.
        <br />
        <br />
        We are not responsible for the content of any other website from which you have accessed the
        Website or to which you may hyperlink from the website and cannot be held liable for any
        loss or damage you incur as a result thereof.
        <br />
        <br />
        These conditions of use are governed by the laws of England and Wales and you agree that the
        English courts shall have exclusive jurisdiction in any dispute.
        <br />
        <br />
        To the extent that any part of these conditions of use is found to be invalid, unlawful or
        unenforceable by any court of competent jurisdiction such part shall to that extent be
        severed from the remaining terms all of which shall remain in full force and effect as
        permitted by law.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/privacy.jpg',
    body: Body,
};
